export const BUGSNAG_API_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY ?? "";

export const releaseStage =
  process.env.BUGSNAG_RELEASE_STAGE ??
  process.env.VERCEL_ENV ??
  process.env.NODE_ENV ??
  "development";

export const appVersion =
  process.env.BUGSNAG_APP_VERSION ??
  process.env.VERCEL_GIT_COMMIT_SHA?.slice(0, 7) ??
  "0.1.0";

export const enabledReleaseStages = ["production"];

export function toError(value: unknown): Error {
  if (value instanceof Error) return value;
  if (typeof value === "string") return new Error(value);
  try {
    return new Error(JSON.stringify(value));
  } catch {
    return new Error(String(value));
  }
}
